import React, { createContext, useContext, useState, useEffect } from 'react';

interface Account {
  userName: string;
  isAlias: boolean;
  isPrimary: boolean;
  workerCount: number;
}

interface AccountContextType {
  activeAccount: string;
  setActiveAccount: (account: string) => void;
  availableAccounts: Account[];
  setAvailableAccounts: (accounts: Account[]) => void;
  primaryUserName: string;
  setPrimaryUserName: (name: string) => void;
}

const AccountContext = createContext<AccountContextType | undefined>(undefined);

export const AccountProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeAccount, setActiveAccountState] = useState<string>('');
  const [availableAccounts, setAvailableAccounts] = useState<Account[]>([]);
  const [primaryUserName, setPrimaryUserName] = useState<string>('');

  const setActiveAccount = (account: string) => {
    setActiveAccountState(account);
    localStorage.setItem('activeAccount', account);
  };

  useEffect(() => {
    const saved = localStorage.getItem('activeAccount');
    if (saved) {
      setActiveAccountState(saved);
    }
  }, []);

  return (
    <AccountContext.Provider value={{
      activeAccount,
      setActiveAccount,
      availableAccounts,
      setAvailableAccounts,
      primaryUserName,
      setPrimaryUserName
    }}>
      {children}
    </AccountContext.Provider>
  );
};

export const useAccount = () => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error('useAccount must be used within AccountProvider');
  }
  return context;
};
